import {createStore, combineReducers, applyMiddleware,compose} from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory} from 'history';
import { routerMiddleware ,routerReducer as router} from 'react-router-redux';
import reducers from './reducers';

const history = createBrowserHistory();
let enhancer = applyMiddleware(thunk,  routerMiddleware(history));


export default function configureStore(initialState) {
    if (process.env.NODE_ENV !== 'production') {
        const devToolsExtension = window.devToolsExtension;
        if (typeof devToolsExtension === 'function') {
            enhancer = compose(enhancer, devToolsExtension());
        }
    }
    const store = createStore(reducers,initialState,enhancer);

    if (module.hot) {
        module.hot.accept('./reducers', () => {
          store.replaceReducer(require('./reducers').default);
        });
      }

    return store
}
